import { reactive } from 'vue'
import actions from '@/store/liveTrivia/actions'
import state from '@/store/liveTrivia/state'
import getters from '@/store/liveTrivia/getters'

export const liveTriviaModule = {
    state: reactive(state),
    actions,
    getters,
}
